import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled, { css } from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';
import withTileAction from '../../util/withTileAction';
import { INSURANCE_SWIMLANE_COPAY_COINSURANCE_TAPPED } from '../../../../../../core/analytics/events';
import {
  hasHitIndividualDeductible,
  hasNoIndividualDeductible,
} from '../../../../../Account/Profile/Insurance/util/insuranceDetails';

import ServiceComingSoonSubtext from '../../../../../Account/Profile/Insurance/util/insurance_insight_subtexts/ServiceComingSoonSubtext';

const Root = styled.div.withConfig({ componentId: 'sc-1v3my7n-0' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  letter-spacing: 0.2px;
`;

const Icon = styled.img.withConfig({ componentId: 'sc-1v3my7n-1' })`
  width: 112px;
  height: 72px;
`;

const Title = styled.div.withConfig({ componentId: 'sc-1v3my7n-2' })`
  color: ${colors.darkText};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.medium};
`;

const PurpleBar = styled.div.withConfig({ componentId: 'sc-1v3my7n-3' })`
  height: 4px;
  width: 100%;
  background-color: ${colors.purpSizzurp};
  border-radius: 8px 8px 0 0;
  margin-bottom: 20px;
`;

const Flex = styled.div.withConfig({ componentId: 'sc-1v3my7n-4' })`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Row = styled.div.withConfig({ componentId: 'sc-1v3my7n-5' })`
  display: flex;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 12px;
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: 0.25px;
  line-height: 16px;
`;

const RowTitle = styled(Row).withConfig({ componentId: 'sc-1v3my7n-6' })`
  letter-spacing: 0.33px;
  line-height: 24px;
  margin-bottom: 16px;
  margin-top: 9px;
`;

type Props = {
  tile: object;
  tileIndex: number;
  userProfile?: object;
  eventName?: string;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  doTileAction?: func;
  insuranceProfile?: object;
  insuranceDetails?: object;
};

class CopayCoinsuranceByServiceComingSoon extends PureComponent<Props> {
  shouldShowAsterisk = () => {
    const { insuranceDetails } = this.props;
    if (hasNoIndividualDeductible(insuranceDetails)) {
      return false;
    }

    return !hasHitIndividualDeductible(insuranceDetails);
  };

  render = () => {
    const { tile, tileIndex, userProfile, insuranceProfile } = this.props;

    return (
      <Root
        onClick={() =>
          this.props.doTileAction(
            tileIndex,
            tile,
            userProfile,
            null,
            INSURANCE_SWIMLANE_COPAY_COINSURANCE_TAPPED
          )
        }
        // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type 'IntrinsicAtt... Remove this comment to see the full error message
        sc={{ tall: this.shouldShowAsterisk() }}
      >
        <PurpleBar />
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'icon' does not exist on type 'object'. */}
        <Icon src={tile.icon} />

        <Flex>
          <RowTitle>
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'object'. */}
            <Title>{tile.title}</Title>
          </RowTitle>

          <Row>
            <ServiceComingSoonSubtext insuranceProfile={insuranceProfile} />
          </Row>
        </Flex>
      </Root>
    );
  };
}

export default withTileAction(CopayCoinsuranceByServiceComingSoon);
